module.exports = __webpack_public_path__ + "static/ko-c4ae9b57a1b24e3b42f2159269d06fda.png";